export { default as AssessmentHeader } from '../../../views/exam-management/AssessmentHeader.jsx';
export { default as AssessmentFooter } from '../../../views/LandingPage/AssessmentDomain/AssessmentFooter.jsx';
export { default as AssessmentHome } from '../../../views/LandingPage/AssessmentDomain/index.jsx';
export { default as Features } from '../../../views/LandingPage/AssessmentDomain/Features.jsx';
export { default as ExamManagement } from '../../../views/exam-management/index.jsx';
export { default as Feedback } from '../../../views/exam-management/rightPart/Feedback.jsx';
